module.exports = __webpack_public_path__ + "fonts/Inter-500-cyrillic-ext32.47734ae.woff2";